import React from 'react';

import styled from '@emotion/styled';

import { useAppSelector } from '../../redux/store';
import TotalApprovedIcon from '../Icons/TotalApprovedIcon';
import TotalPendingIcon from '../Icons/TotalPendingIcon';
import TotalProcessedIcon from '../Icons/TotalProcessedIcon';
import TotalReceivedIcon from '../Icons/TotalReceivedIcon';
import TotalRejectedIcon from '../Icons/TotalRejectedIcon';
import Card from './Card';

const BAVerificationStatsCard = () => {
  const { verificationStats } = useAppSelector(
    (state) => state.baVerificationStatsData,
  );

  return (
    <CardContainerWrapper>
      {/* section 1 */}
      <Card.Root padding='12px 24px' height='130px'>
        <Card.Header padding='12px'>
          <TotalReceivedIcon /> Total Received
        </Card.Header>
        <Card.Body>
          <Card.LargeNumber type='default'>
            {verificationStats?.totalOnboardings ?? 0}
          </Card.LargeNumber>
        </Card.Body>
      </Card.Root>

      {/* section 2 */}
      <Card.Root padding='12px 24px' height='130px'>
        <Card.Header padding='12px'>
          <TotalApprovedIcon /> Total Approved
        </Card.Header>
        <Card.Body>
          <Card.LargeNumber type='default'>
            {verificationStats?.approvedOnboardings ?? 0}
          </Card.LargeNumber>
        </Card.Body>
      </Card.Root>

      {/* section 3 */}
      <Card.Root padding='12px 24px' height='130px'>
        <Card.Header padding='12px'>
          <TotalRejectedIcon /> Total Rejected
        </Card.Header>
        <Card.Body>
          <Card.LargeNumber type='default'>
            {verificationStats?.rejectedOnboardings ?? 0}
          </Card.LargeNumber>
        </Card.Body>
      </Card.Root>

      {/* section 4 */}
      <Card.Root padding='12px 24px' height='130px'>
        <Card.Header padding='12px'>
          <TotalPendingIcon /> Total Pending
        </Card.Header>
        <Card.Body>
          <Card.LargeNumber type='default'>
            {verificationStats?.pendingOnboardings ?? 0}
          </Card.LargeNumber>
        </Card.Body>
      </Card.Root>

      {/* section 5 */}
      <Card.Root padding='12px 24px' height='130px'>
        <Card.Header padding='12px'>
          <TotalProcessedIcon /> Total Processed
        </Card.Header>
        <Card.Body>
          <Card.LargeNumber type='default'>
            {verificationStats?.processedOnboardings ?? 0}
          </Card.LargeNumber>
        </Card.Body>
      </Card.Root>
    </CardContainerWrapper>
  );
};

export default BAVerificationStatsCard;

const CardContainerWrapper = styled.div`
  width: 100%;

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  width: 100%;
`;
